<template>
  <div class="step-box">
    <i18n
      path="demo.demoRegistration.stepMenu.step1.step"
      tag="div"
      class="step step-1">
      <template #text
        ><span>{{
          $t('demo.demoRegistration.stepMenu.step1.text')
        }}</span></template
      >
    </i18n>
    <i18n
      path="demo.demoRegistration.stepMenu.step2.step"
      tag="div"
      class="step step-2">
      <template #text
        ><span>{{
          $t('demo.demoRegistration.stepMenu.step2.text')
        }}</span></template
      >
    </i18n>
    <i18n
      path="demo.demoRegistration.stepMenu.step3.step"
      tag="div"
      class="step step-3">
      <template #text
        ><span>{{
          $t('demo.demoRegistration.stepMenu.step3.text')
        }}</span></template
      >
    </i18n>
    <i18n
      path="demo.demoRegistration.stepMenu.step4.step"
      tag="div"
      class="step step-4">
      <template #text
        ><span>{{
          $t('demo.demoRegistration.stepMenu.step4.text')
        }}</span></template
      >
    </i18n>
  </div>
</template>

<script>
  export default {
    name: 'StepBox',
    props: {
      step: {
        type: Number,
      },
    },
  };
</script>
